import qs from "qs";

export enum AppPages {
  ApplicationIndex = "/application",
  UserSettings = "/user",
  UserEmailSettings = "/user/email",
  AdminUsers = "/admin/users",
  AdminUserProfile = "/admin/user",
  AdminApplications = "/admin/applications",
  SignIn = "/api/auth/signin",
  Registration = "/signin/complete",
  VerifyRequest = "/api/auth/signin",
  NotAuthorized = "/403",
  NotFound = "/404",

  ApplicationNavIndex = "",
  ApplicationProfileIndex = "profile",

  ApplicationProfileRefereesIndex = "profile/referees",
  ApplicationProfilePersonalStatementIndex = "profile/personal-statement",
  ApplicationProfileRefereesSelfIndex = "profile/referees/self",
  ApplicationProfileRefereesPotential = "profile/referees/potential",
  ApplicationProfileRefereesChoice = "profile/referees/choice",
  ApplicationProfileRefereesDetails = "profile/referees/details",
  ApplicationProfileRefereesRefLetter = "profile/referees/ref-letter",
  ApplicationProfileDocGenerationIndex = "profile/doc-generation",
  ApplicationProfileDocGenerationSuccess = "profile/doc-generation/success",
  ApplicationProfileDocs = "applicationDocs",
  ApplicationProfilePublicProfileBoosting = "profile/PPB",

  ApplicationProfileProfessionalJourneyLegacyIndex = "profile/professional-journey/v1",
  ApplicationProfileProfessionalJourneyLegacyCompany = "profile/professional-journey/v1/company",
  ApplicationProfileProfessionalJourneyLegacyEntrepreneurship = "profile/professional-journey/v1/entrepreneurship",

  ApplicationProfileProfessionalJourneyIndex = "profile/professional-journey",
  ApplicationProfileProfJourneyPotential = "profile/professional-journey/potential",
  ApplicationProfileProfJourneyDetails = "profile/professional-journey/details",

  ApplicationProfileSelfProfessionalJourneyIndex = "profile/professional-journey/self",

  ApplicationProfileExternalProfileIndex = "profile/external-profile",
  ApplicationCheckoutSuccess = "checkout/success",
  ApplicationCheckoutError = "checkout/error",

  ApplicationNextSteps = "next-steps",
  ApplicationApplyWithOurSupport = "apply-with-our-support",

  ApplicationProfileSectionDoc = "profile/provide-docs",

  ApplicationGTVIndex = "/gtv",
  ApplicationO1Index = "/o1",
}

export enum VisaType {
  O1 = "o1",
  GTV = "gtv",
}

interface ApplicationRelLinkOptions {
  applicationId: string;
  link: string;
  query?: Record<string, any>;
  visaType?: string;
}

export const getApplicationRelLink = ({
  applicationId,
  link,
  query,
  visaType,
}: ApplicationRelLinkOptions): string => {
  const applicationPrefix = visaType
    ? {
        [VisaType.GTV]: AppPages.ApplicationGTVIndex,
        [VisaType.O1]: AppPages.ApplicationO1Index,
      }[visaType]
    : AppPages.ApplicationIndex;

  return [
    `${applicationPrefix}/${applicationId}/${link}`,
    query ? `?${qs.stringify(query)}` : "",
  ].join("");
};
